/**
 * Functions to handle NodeEditor saving options
 */

export default {
  methods: {
    $_savingOptionsMixin_onEditFinish() {
      this.$emit('editFinish');
    },
    $_savingOptionsMixin_onDelete() {
      this.$emit('delete');
    },
  },
};
